export default "__VITE_ASSET__05dd8ff8__"